import { render, staticRenderFns } from "./MaterialCreateView.vue?vue&type=template&id=66b838ac"
import script from "./MaterialCreateView.vue?vue&type=script&lang=js"
export * from "./MaterialCreateView.vue?vue&type=script&lang=js"
import style0 from "./MaterialCreateView.vue?vue&type=style&index=0&id=66b838ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports